/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-08-22 14:57:33
 */ 
/* 
 * 接口统一集成模块
 */

//  图片上传地址
import * as  imgAdd from './moudules/imgAdd'
import * as login from './moudules/login'
import * as user from './moudules/user'
import * as dept from './moudules/dept'
import * as role from './moudules/role'
import * as menu from './moudules/menu'
import * as dict from './moudules/dict'
import * as log from './moudules/log'
import * as personPass from './moudules/personPass'
import * as personnel from './moudules/personnel'
import * as PlatformEntry from './moudules/PlatformEntry'
import * as addimg from './moudules/addimg'
import * as home from './moudules/home'
import * as message from './moudules/message'
import * as dataSc from './moudules/dataScreen'

// 小区AI能力层配置
import * as aiSave from './moudules/AIsave'
//楼栋配置
import * as build from './moudules/build'
//三合力通
import * as three from './moudules/three'
//人员审核
import * as personReview from './moudules/personReview'
//设备列表
import * as resource from './moudules/resource'
//数据同步
import * as system from './moudules/system'
//预警消息
import * as warn from './moudules/warn'
//车辆通行
import * as passCar from './moudules/passCar'
//车闸
import * as brake from './moudules/brake'
//社彩推送
import * as social from './moudules/social'
//微信
import * as wxNotic from './moudules/wxNotic'
import * as repair from './moudules/repair'
import * as suggestion from './moudules/suggestion'
import * as wxJob from './moudules/wxJob'
import * as openDoor from './moudules/openDoor'
// 智能手环
import * as bracelct from './moudules/bracelct'
import * as first from './moudules/first'
// 默认全部导出
export default {
    login,
    user,
    dept,
    role,
    menu,
    dict,
    log,
    build,
    aiSave,
    three,
    personPass,
    personReview,
    resource,
    personnel,
    PlatformEntry,
    imgAdd,
    home,
    system,
    message,
    warn,
    passCar,
    brake,
    wxNotic,
    repair,
    suggestion,
    wxJob,
    social,   
    dataSc,
    openDoor,
    bracelct,
    first
}


// WEBPACK FOOTER //
// ./src/http/api.js